var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M8.479 24.097l7.02-6.181 12.193-.295 6.463 6.213.315 13.791-8.107 7.773h-9.907l-7.977-8.953V24.097z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M41.428 19.11l-2.299 1.948a5.296 5.296 0 01-3.422 1.254h-3.8a2.426 2.426 0 01-2.426-2.426v-.001a2.324 2.324 0 00-2.324-2.324h-11.4a2.323 2.323 0 00-2.324 2.324v.001a2.426 2.426 0 01-2.426 2.426h-.1a2.427 2.427 0 00-2.428 2.428v12.234a2.426 2.426 0 002.428 2.428h.002a2.524 2.524 0 012.524 2.524v.518a2.954 2.954 0 002.954 2.954h10.14a2.955 2.955 0 002.954-2.954v-.002a3.039 3.039 0 013.04-3.04h3.186c1.253 0 2.465.445 3.422 1.254L49.9 49.779a2.039 2.039 0 003.356-1.555V13.49a2.04 2.04 0 00-3.356-1.555l-1.365 1.156M53.256 26.331c2.521 0 4.567 2.028 4.567 4.526 0 2.498-2.046 4.526-4.567 4.526M15.499 31.395l6.222-6.222M21.183 37.079l6.222-6.222M34.47 22.312v17.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M61.661 23.922l5.678-4.229M61.661 37.792l5.678 4.229M64.132 30.857l9.055-.103"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M17.799 45.398H24.743V63.548H17.799z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.ff9c639323e0a32fb5b041d3b5b7f136.svg";
export { ForwardRef as ReactComponent };